import { bankEndPoint } from "./base.config";

export const transactionInfo = {
  get: `${bankEndPoint}/api/bank-template/get-transaction-info`,
}